import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6e1d8f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account" }
const _hoisted_2 = {
  key: 0,
  class: "create"
}
const _hoisted_3 = { class: "box" }
const _hoisted_4 = { class: "ws_mb20" }
const _hoisted_5 = {
  key: 1,
  class: "edit-account"
}
const _hoisted_6 = { class: "box" }
const _hoisted_7 = { class: "ws_mb20" }
const _hoisted_8 = { class: "ws_mb12" }
const _hoisted_9 = { class: "ws_mb12" }
const _hoisted_10 = { class: "ws_mt30" }
const _hoisted_11 = { class: "header" }
const _hoisted_12 = { class: "dialog-footer" }
const _hoisted_13 = { class: "tip" }
const _hoisted_14 = { class: "header" }
const _hoisted_15 = { class: "dialog-footer" }

import { Plus, WarningFilled, InfoFilled } from '@element-plus/icons-vue'
import { ref, onMounted, computed } from 'vue'
import {
  appSecretQuery,
  appSecretDelete,
  appSecretAdd,
  appSecretUpdate,
} from '@/api'
import { CODE_ENUM } from '@/common/enum'
import { ElMessage } from 'element-plus'
import moment from 'moment'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const t = i18n.global.t

const appSecretType = computed(() => {
  return !!account.value.appKey
})

const appSecret = computed(() => {
  return show.value
    ? account.value.appSecret
    : account.value.appSecret.replace(/./g, '*')
})

const show = ref(false)
const toggleSecret = () => {
  show.value = !show.value
}

onMounted(() => {
  queryAccount()
})

const account = ref({
  appKey: '',
  appSecret: '',
  updateTime: '',
})
const queryAccount = async () => {
  const res: any = await appSecretQuery()
  if (res?.code === CODE_ENUM.SUCCESS) {
    account.value = {
      ...res.data,
    }
  }
}

const removeDialogVisible = ref(false)
const removeLoading = ref(false)
const toRemoveSecret = async () => {
  removeLoading.value = true
  const res: any = await appSecretDelete().finally(() => {
    removeLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(t('C_ACCOUNT.delSuccess'))
    removeDialogVisible.value = false
    queryAccount()
  }
}

const createLoading = ref(false)
const createSecret = async () => {
  createLoading.value = true
  const res: any = await appSecretAdd().finally(() => {
    createLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(t('C_ACCOUNT.createSuccess'))
    queryAccount()
  }
}

const updateDialogVisible = ref(false)
const updateLoading = ref(false)
const updateSecret = async () => {
  updateLoading.value = true
  const res: any = await appSecretUpdate().finally(() => {
    updateLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    updateDialogVisible.value = false
    ElMessage.success(t('C_ACCOUNT.resetSuccess'))
    queryAccount()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_View = _resolveComponent("View")!
  const _component_Hide = _resolveComponent("Hide")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_unref(appSecretType))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('C_ACCOUNT.apiCreate')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('C_ACCOUNT.createTip')), 1),
              _createVNode(_component_el_button, {
                onClick: createSecret,
                loading: createLoading.value,
                icon: _unref(Plus),
                class: "ws_mt30",
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('C_ACCOUNT.btnCreate')), 1)
                ]),
                _: 1
              }, 8, ["loading", "icon"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(appSecretType))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('C_ACCOUNT.apiTitle')), 1),
              _createElementVNode("p", _hoisted_8, "Access ID: " + _toDisplayString(account.value.appKey), 1),
              _createElementVNode("p", _hoisted_9, [
                _createElementVNode("span", null, "Access Secret: " + _toDisplayString(_unref(appSecret)), 1),
                _createVNode(_component_el_icon, {
                  onClick: toggleSecret,
                  class: "ws_ml50 toggle"
                }, {
                  default: _withCtx(() => [
                    (show.value)
                      ? (_openBlock(), _createBlock(_component_View, { key: 0 }))
                      : (_openBlock(), _createBlock(_component_Hide, { key: 1 }))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('C_ACCOUNT.updateTime')) + "：" + _toDisplayString(_unref(moment)(account.value.updateTime).format(_ctx.$t('C_ACCOUNT.formatterTime'))), 1),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_button, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (updateDialogVisible.value = true)),
                  class: "ws_mr8",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('C_ACCOUNT.btnReset')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  plain: "",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (removeDialogVisible.value = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('C_ACCOUNT.btnDel')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: removeDialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((removeDialogVisible).value = $event)),
      width: "500px",
      class: "ws_remove_dialog"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_icon, {
            color: "#F56C6C",
            size: "26",
            class: "ws_mr10"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(WarningFilled))
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('C_ACCOUNT.delTitle')), 1)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_12, [
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (removeDialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('C_ACCOUNT.btnCancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            loading: removeLoading.value,
            type: "primary",
            onClick: toRemoveSecret
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('C_ACCOUNT.btnDelete')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('C_ACCOUNT.delTip')), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: updateDialogVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((updateDialogVisible).value = $event)),
      width: "500px"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_icon, {
            color: "#E6A23C",
            size: "26",
            class: "ws_mr10"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(InfoFilled))
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('C_ACCOUNT.resetTitle')), 1)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_15, [
          _createVNode(_component_el_button, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (updateDialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('C_ACCOUNT.btnCancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            loading: updateLoading.value,
            type: "primary",
            onClick: updateSecret
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('C_ACCOUNT.btnYes')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('C_ACCOUNT.rersetTip')), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})